module.exports = __webpack_public_path__ + "img/ImageHolder.6eb7010f.png";